import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Snackbar from '@material-ui/core/Snackbar';

// import Email from "@material-ui/icons/Email";

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";

import CustomNotification from "../LandingPage/Sections/CustomNotification";

import loginPageStyle from "../../assets/jss/material-kit-pro-react/views/loginPageStyle.jsx";

import { loginUser } from '../../actions/authActions';
import bgImg from "../../assets/img/landing-bg.jpg";

class LoginPage extends React.Component {
    constructor() {
        super();
        this.state = {
            openNotification: false,
            variantNotification: '',
            messageNotification: '',
            username: '',
            password: '',
            errors: {}
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.authReducer.isAuthenticated) {
            /*
            TODO: Crear vista dashboard
            * */
            this.props.history.push('/profile');
        }

        if (!!nextProps.errors && !!nextProps.errors.message) {
            this.handleClickNotification(nextProps.errors.message, 'error');
            let errors = {};
            if (!!nextProps.errors.errors && nextProps.errors.errors.length>0) {
                for (let i=0; i<nextProps.errors.errors.length; i++) {
                    let actualField = nextProps.errors.errors[i];
                    errors[actualField.field] = actualField.message;
                }
                this.setState({ errors });
            }
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        const { authReducer, history, location } = this.props;

        if (authReducer.isAuthenticated) {
            /*
            TODO: Crear vista dashboard
            * */
            history.push({ pathname: '/profile', state: { message: 'Ya tienes una sesión iniciada', type: 'warning' } });
        }

        if (!!location.state && !!location.state.message) {
            this.handleClickNotification(location.state.message, location.state.type);
        }
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    onChangeCustomInput = () => e => {
        if (!!e.target.id) {
            this.setState({ [e.target.id]: e.target.value, errors: {} });
        } else {
            console.error('Error actualizando la informacion ingresada', 'error');
        }
    };

    onSubmit = e => {
        e.preventDefault();

        const { username, password } = this.state;

        let userData = {
            username,
            password
        };

        this.props.loginUser(userData);
    };

    render() {
        const { classes } = this.props;
        const { errors } = this.state;

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Iniciar Sesión | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co" />
                    <meta name="description" content="Inicia sesión en Vivamos el Campo - Turismo Rural, gestiona tus reservaciones y tu información de usuario" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 180,
                        color: "white"
                    }}
                />
                <div
                    className={classes.pageHeader}
                    style={{
                        backgroundImage: "url(" + bgImg + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "top center"
                    }}
                >
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={4}>
                                <Card>
                                    {/* Custom Notification */}
                                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                                        <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                                    </Snackbar>
                                    {/* End Custom Notification */}

                                    <form className={classes.form} onSubmit={this.onSubmit}>
                                        <CardHeader color="success" signup className={classes.cardHeader}>
                                            <h4 className={classes.cardTitle}>Iniciar Sesión</h4>
                                            {/*<p className={`${classes.textCenter}`}>
                                                Usa una red social
                                            </p>
                                            <div className={classes.socialLine}>
                                                <Button
                                                    justIcon
                                                    color="transparent"
                                                    className={classes.iconButtons}
                                                    onClick={e => e.preventDefault()}
                                                >
                                                    <i className="fab fa-facebook" />
                                                </Button>

                                                <Button
                                                    justIcon
                                                    color="transparent"
                                                    className={classes.iconButtons}
                                                    onClick={e => e.preventDefault()}
                                                >
                                                    <i className="fab fa-google-plus-g" />
                                                </Button>

                                                <Button
                                                    justIcon
                                                    color="transparent"
                                                    className={classes.iconButtons}
                                                    onClick={e => e.preventDefault()}
                                                >
                                                    <i className="fab fa-twitter" />
                                                </Button>
                                            </div>*/}
                                        </CardHeader>

                                        {/*<p className={`${classes.description} ${classes.textCenter}`}>
                                            O ingresa tus datos
                                        </p>*/}
                                        <CardBody signup>
                                            <CustomInput
                                                id="username"
                                                formControlProps={{ fullWidth: true }}
                                                labelText= {!!errors.username ? errors.username : "Email o nombre de usuario"}
                                                error = {!!errors.username}
                                                inputProps={{
                                                    type: "username",
                                                    defaultValue: this.state.username,
                                                    onChange: this.onChangeCustomInput(),
                                                    required: true
                                                }}
                                            />
                                            <CustomInput
                                                id="password"
                                                labelText= {!!errors.password ? errors.password : "Contraseña"}
                                                error = {!!errors.password}
                                                formControlProps={{ fullWidth: true }}
                                                inputProps={{
                                                    type: "password",
                                                    defaultValue: this.state.password,
                                                    onChange: this.onChangeCustomInput(),
                                                    required: true
                                                }}
                                            />
                                        </CardBody>
                                        <br/>
                                        <div className={classes.textCenter}>
                                            <Button round color="success" type="submit">
                                                Acceder
                                            </Button>
                                        </div>
                                    </form>

                                    <div className={classes.textCenter}>
                                        <span>¿No tienes una cuenta?</span>
                                        <Link to="/signup">
                                            <Button simple color="success" size="lg">
                                                Regístrate
                                            </Button>
                                        </Link>
                                    </div>

                                    <div className={classes.textCenter}>
                                        <Link to="/olvido-contrasena">
                                            <b>Olvidé mi contraseña</b>
                                        </Link>
                                    </div>

                                    <br/>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div>

                    <Footer
                        className={classes.footer}
                        content={
                            <div>
                                <div className={classes.left}>
                                    <List className={classes.list}>
                                        <ListItem className={classes.inlineBlock}>
                                            <Link to="/" className={classes.block}> Inicio </Link>
                                        </ListItem>
                                        <ListItem className={classes.inlineBlock}>
                                            <Link to="/signup" className={classes.block}> Registrarse </Link>
                                        </ListItem>
                                        <ListItem className={classes.inlineBlock}>
                                            <Link to="/contacto" className={classes.block}> Contacto </Link>
                                        </ListItem>
                                    </List>
                                </div>

                                <div className={classes.right}>&copy; {1900 + new Date().getYear()} Vivamos el Campo. Todos los derechos reservados.</div>
                            </div>
                        }
                    />
                </div>
            </div>
        );
    }
}

LoginPage.propTypes = {
    loginUser: PropTypes.func.isRequired,
    authReducer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    authReducer: state.authReducer,
    errors: state.errors
});

export default connect(mapStateToProps, { loginUser })( withStyles(loginPageStyle)(LoginPage) );



// WEBPACK FOOTER //
// ./src/views/LoginPage/LoginPage.jsx